import { put, call, take, fork } from 'redux-saga/effects'
import { openaiSendCourseCreationGetTitleRequestService } from '../../api/assignment'
import { OPENAI_SEND_COURSE_CREATION_GET_TITLE_REQUEST } from '../../reducers/assignment/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* openAiCourseCreationGetTitleRequestFlow(payload) {
  try {
    const { profession, audience, description, language, purpose, callback } =
      payload

    const response = yield call(
      openaiSendCourseCreationGetTitleRequestService,
      profession,
      audience,
      description,
      language,
      purpose,
    )

    yield put(operationSuccess())

    callback(response.data)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* openAiCourseCreationGetTitleRequestWatcher() {
  while (true) {
    const action = yield take(OPENAI_SEND_COURSE_CREATION_GET_TITLE_REQUEST)
    const { payload } = action

    yield fork(
      generalSaga,
      openAiCourseCreationGetTitleRequestFlow,
      payload,
      false,
    )
  }
}
